import { createStore, applyMiddleware } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension';
import createAppReducer from './createAppReducer';
import createAppMiddlewares from './createAppMiddlewares';

export default function createAppStore({
  config,
  cookies,
  errorTracker,
  history,
  initialState,
  services,
}) {
  const middlewares = createAppMiddlewares({
    cookies,
    debug: config.debug,
    errorTracker,
    history,
    services,
  });
  const enhancer = applyMiddleware(...middlewares);
  const store = createStore(
    createAppReducer(),
    initialState,
    __SERVER__ ? enhancer : composeWithDevTools(enhancer),
  );

  store.asyncReducers = {};
  store.injectAsyncReducer = (name, asyncReducer) => {
    if (store.asyncReducers[name]) {
      return;
    }

    store.asyncReducers[name] = asyncReducer; // eslint-disable-line no-param-reassign
    store.replaceReducer(createAppReducer(store.asyncReducers));
  };

  return store;
}
